export default __webpack_public_path__ + "images/ce8b59a5f92f51cefbb4209ee83c0c0d-music_desktop.webp";